module.exports = __webpack_public_path__ + "static/media/jeff-sheldon.67abf67e.jpg";